import { CircularProgress } from '@material-ui/core'
import axios from 'axios'
import { StaticImage } from 'gatsby-plugin-image'
import { withTranslation } from 'gatsby-plugin-react-i18next'
import React, { Component } from 'react'
import { ValidatorForm } from 'react-form-validator-core'

import { logAmplitudeEvent } from '../../../services/amplitude'
import { processInput } from '../../../services/validators/utils'
import { TextValidator, TextAreaValidator, SelectValidator } from '../../../services/validators/Validators'

import "./Contact.css"

const background = {
  src: '../../../images/contact.jpg',
  alt: 'Person talking into phone'
}
class Contact extends Component {
  constructor(props) {
    super(props)
    this.setProperty = this.setProperty.bind(this)
    this.state = {
      showDialog: false,
      loading: false,
      form: {},
      resMessage: null,
      resError: false
    }
  }
  setProperty(key, value, validators) {
    const { form } = this.state
    this.setState({
      form: {
        ...form,
        ...processInput(key, value, validators)
      },
      resError: false,
      resMessage: null
    })
  }
  logAmplitudeEvent() {
    const { reasonForContact, message } = this.state
    logAmplitudeEvent('Used contact form', {
      contactReason: reasonForContact,
      message
    })
  }
  dismissDialog() {
    this.setState({
      showDialog: false
    })
  }
  triggerTimeout(e) {
    if (e.target.value) {
      clearTimeout(this.amplitudeTimeout)
        this.amplitudeTimeout = setTimeout(() => {
          this.logAmplitudeEvent()
      }, 10000)
    }
  }
  submit() {
    const { t } = this.props
    const { form } = this.state
    this.setState({
      loading: true
    })
    axios.post(`${process.env.BACKEND_URL}api/inquiries`, form)
      .then(res => {
        this.setState({
          showDialog: true,
          loading: false,
          form: {}
        })
      })
      .catch(err => {
        this.setState({
          loading: false,
          resMessage: t(`landing:contact.form.error`),
          resError: true
        })
      })
  }
  render() {
    const { t } = this.props
    const { form, showDialog, loading, resMessage, resError } = this.state
    return (
      <div className="home-contact-wrap">
        <div className="landing-anchor" id="contact" />
        <div className="hc-title-wrap">
          <h2 className="hc-title">
            <span className="hc-title-dot dot" />
            <span className="hc-title-text">{t('landing:contact.heading')}</span>
          </h2>
        </div>
        <div className="home-contact-inner-wrap">
          <StaticImage 
            className="hc-background"
            {...background} 
          />
          <ValidatorForm className="hc-form" instantValidate={false} onSubmit={(e) => this.submit(e)}>
            <div className="hc-form-personal-info">
              {t(`landing:contact.form.personalInfo`, { returnObjects: true }).map(el => {
                switch (el.type) {
                  case 'input':
                    return (
                      <TextValidator
                        key={el.id}
                        type={el.type}
                        placeholder={el.placeholder}
                        value={form[el.id]}
                        validators={el.validators}
                        errorMessages={el.errorMessages}
                        autoComplete={el.autoComplete}
                        onChange={(e) => this.setProperty(el.id, e.target.value, el.validators)}
                      />
                    )
                  case 'select':
                    return (
                        <SelectValidator
                          key={el.id}
                          placeholder={el.placeholder}
                          value={form[el.id]}
                          validators={el.validators}
                          errorMessages={el.errorMessages}
                          options={el.options}
                          onChange={(e) => this.setProperty(el.id, e.target.value, el.validators)}
                        />
                    )
                  default:
                    return null
                }
              })}
            </div>
            <div className="hc-form-message">
              <TextAreaValidator
                placeholder={t(`landing:contact.form.message.placeholder`)}
                rows="4"
                value={form.message}
                validators={t(`landing:contact.form.message.validators`, { returnObjects: true })}
                errorMessages={t(`landing:contact.form.message.errorMessages`, { returnObjects: true })}
                onChange={(e) => this.setProperty('message', e.target.value, t(`landing:contact.form.message.validators`, { returnObjects: true }))}
                onFocus={() => this.amplitudeTimeout && clearTimeout(this.amplitudeTimeout)}
                onBlur={e => this.triggerTimeout(e)}
              />
              <button
                className="submit-button"
                type="submit"
                disabled={loading}
              >
                {t(`landing:contact.form.submit`)}
                {loading && (
                  <div className="circular-progress-wrap themed">
                    <CircularProgress size={16} thickness={5} />
                  </div>
                )}
              </button>
              <p className={`res-message center ${resError ? 'error' : ''}`}>{resMessage}</p>
            </div>
          </ValidatorForm>
        </div>
        {showDialog && (
          <div className="dialog-wrap">
            <div role="button" tabIndex="0" className="dialog-background" onClick={() => this.dismissDialog()} />
            <div className="dialog-content">
              <div role="button" tabIndex="0" className="dialog-close-button" onClick={() => this.dismissDialog()} >
                <div className="dialog-close-line line-1" />
                <div className="dialog-close-line line-2" />
              </div>
              <p className="dialog-text">
                {t(`landing:contact.form.dialog.text`)}
              </p>
              <p>
                {t(`landing:contact.form.dialog.warmly`)}
              </p>
              <p>
                {t(`landing:contact.form.dialog.signature`)}
              </p>
            </div>
          </div>
        )}
      </div>
    )
  }
}
export default withTranslation(['landing'])(Contact)
